import React from 'react';
import { Link } from 'react-router-dom';
import { CHAIN } from '../chain/config';

// /news — ecosystem updates. Static for now; the cards read like a changelog
// of what's live on the platform.
const NEWS = [
    {
        icon: '🚀',
        tag: 'LAUNCH',
        date: 'September 2026',
        title: 'BirrPlug is live — the on-chain marketplace opens its doors',
        text: 'Shop local businesses, pay in BRC straight from your wallet, and track every order to your door. Every payment settles on BRDPoSChain and is verifiable on the public explorer.',
        cta: { label: 'Start shopping', to: '/search' },
    },
    {
        icon: '🔐',
        tag: 'ACCOUNTS',
        date: 'September 2026',
        title: 'Passwords are gone — your wallet is your account',
        text: 'Sign a free message with BirrWallet or MetaMask to log in. Accounts are created on first signature, and sellers get paid in BRC directly to the wallet they sign up with.',
        cta: { label: 'Create an account', to: '/signup' },
    },
    {
        icon: '🏬',
        tag: 'SELLERS',
        date: 'September 2026',
        title: 'Seller subscriptions: Starter, Pro, and Elite',
        text: 'Start free with 10 product listings. Upgrade to Pro (25 BRC / 30 days) or Elite (100 BRC / 30 days) for bigger catalogs and better placement — paid from your wallet, verified on-chain, active in seconds.',
        cta: { label: 'Open your shop', to: '/join/business' },
    },
    {
        icon: '📦',
        tag: 'SHIPPING',
        date: 'September 2026',
        title: 'End-to-end order tracking with carrier events',
        text: 'Sellers attach carrier and tracking numbers, push progress updates, and buyers follow a live timeline from pending to delivered — with the payment receipt linked on-chain.',
        cta: { label: 'How it works', to: '/' },
    },
];

export default function News() {
    return (
        <div className="bp-news-page container">
            <div className="bp-sec-head" style={{ textAlign: 'center' }}>
                <span className="bp-sec-label">UPDATES</span>
                <h2 className="bp-sec-title">News & Ecosystem</h2>
                <p className="bp-join-lede">What's new on BirrPlug and across {CHAIN.name}.</p>
            </div>

            <div className="bp-news-list">
                {NEWS.map((n, i) => (
                    <article className="bp-news-card" key={i}>
                        <span className="bp-news-ico" aria-hidden="true">{n.icon}</span>
                        <div className="bp-news-body">
                            <div className="bp-news-meta">
                                <span className="bp-news-tag">{n.tag}</span>
                                <span className="bp-dim">{n.date}</span>
                            </div>
                            <h3>{n.title}</h3>
                            <p>{n.text}</p>
                            <Link to={n.cta.to} className="bp-join-selllink">{n.cta.label} →</Link>
                        </div>
                    </article>
                ))}
            </div>
        </div>
    );
}
